import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ITotalFinancials } from "../domain/ITotalFinancials";
import { IYearRequestParams } from "../domain/IYearRequestParams";
import { StatisticsService } from "../services/statistics.service";
import { RootState } from "reducers";

interface TotalFinancialsStatisticsState {
    loading: boolean;
    statistics?: ITotalFinancials;
    error: any;
}

const initialState: TotalFinancialsStatisticsState = {
    loading: false,
    statistics: undefined,
    error: undefined
}

export const getTotalFinancialsStatistics = createAsyncThunk(
    "Statistics/getTotalFinancialsStatistics",
    async (data?: IYearRequestParams) => {
        try {
            const result = await StatisticsService.getTotalFinancials(data);
            return result;
        } catch (err) {
            setError(err);
        }
    }
);

export const TotalFinancialsStatisticsSlice = createSlice({
    name: "TotalFinancialsStatistics",
    initialState: initialState,
    reducers: {
        setTotalFinancialsStatistics: (
            state,
            action: PayloadAction<ITotalFinancials>
        ) => {
            state.statistics = action.payload;
        },
        setError: (state, action: PayloadAction<any>) => {
            state.error = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getTotalFinancialsStatistics.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getTotalFinancialsStatistics.fulfilled, (state,action) => {
            state.loading = false;
            state.statistics = action.payload ? action.payload : undefined;
        });
        builder.addCase(getTotalFinancialsStatistics.rejected, (state,action) => {
            state.loading = false;
            state.error = action.error;
        });
    }
})

export const selectState = (state:RootState) => state.statistics.totalfinancials;

export const { setError } = TotalFinancialsStatisticsSlice.actions;

export default TotalFinancialsStatisticsSlice.reducer;